import style from './TestLabel.sass'

export default function TestLabel(  ) {
  return <div className={style.testLabel}>
    <span>Modo de pruebas</span>
  </div>
}
